enum EInstructionRemittanceStatus {
  PENDING = 0,
  SENT = 1,
  APPROVED = 2,
  REJECTED = 3,
  WAITING_APPROVAL = 5,
}

export default EInstructionRemittanceStatus;
